var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bottomContainer"},[_c('button',{staticClass:"button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" Continuar sem pedido médico ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }